import React from "react";
import Layout from "../Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import {
  Edit,
  Delete,
} from '@material-ui/icons/';
import { withRouter } from "react-router";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import MuiAlert from "@material-ui/lab/Alert";

import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  table: {
    overflowX: "auto",
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  alert: {
    marginTop: theme.spacing(2),
  },
  dateCol: {
    width: "170px",
  },
  buttonCol: {
    textAlign: "center",
    width: "170px",
  },
  buttonRed: {
    color: "rgb(220, 0, 78)",
    "&:hover": {
      backgroundColor: "rgba(220, 0, 78, 0.04)",
    },
  },
}));

function Dtm(props) {
  const { request } = useApi();
  const auth = useAuth();
  const classes = useStyles();

  const [dtms, setDtms] = React.useState([]);
  const [isShowModal, setIsShowModal] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState(null);
  const [success, setSuccess] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState(null);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - DTM告知管理";

    if (props.location.search.indexOf("create") > -1) {
      setSuccess(true);
      setSuccessMessage("登録が完了しました");
    }
    if (props.location.search.indexOf("edit") > -1) {
      setSuccess(true);
      setSuccessMessage("更新が完了しました");
    }
    if (props.location.search.indexOf("delete") > -1) {
      setSuccess(true);
      setSuccessMessage("削除が完了しました");
    }
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchDtms();
  }, [auth.state.token]);

  const fetchDtms = () => {
    request({
      method: "GET",
      url: `admin/dtm_notices`,
    }).then((result) => {
      console.log(result.data.data);
      setDtms(result.data.data);
    });
  };

  const onClickEditButton = (id) => {
    props.history.push(`/admin/dtm/edit/${id}`);
  };

  const openDialog = (id) => {
    setDeleteId(id);
    setIsShowModal(true);
  };

  const deleteDtm = () => {
    request({
      method: "DELETE",
      url: `admin/dtm_notices/${deleteId}`,
    }).then(() => {
      fetchDtms();
      setIsShowModal(false);
    });
  };

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
  
    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell>{row.label}</TableCell>
          <TableCell>{row.desc}</TableCell>
          <TableCell className={classes.dateCol}>{row.valid_from ? dayjs(row.valid_from).format("YYYY/MM/DD HH:mm:ss") : '-'}</TableCell>
          <TableCell className={classes.dateCol}>{row.valid_until ? dayjs(row.valid_until).format("YYYY/MM/DD HH:mm:ss") : '-'}</TableCell>
          <TableCell className={classes.buttonCol}>
            <IconButton 
              color="primary" 
              aria-label="add an Edit"
              onClick={() => onClickEditButton(row.id)}
            >
              <Edit />
            </IconButton>
            <IconButton 
              className={classes.buttonRed} 
              aria-label="add an Delete"
              onClick={() => openDialog(row.id)}
            >
              <Delete />
            </IconButton>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  };

  return (
    <Layout
      content={
        <>
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                DTM告知一覧
              </Typography>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>告知タイプ</TableCell>
                    <TableCell>概要</TableCell>
                    <TableCell>掲載開始日時</TableCell>
                    <TableCell>掲載終了日時</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dtms.map(
                    function (row, index) {
                      return <Row key={index} index={index+1} row={row} />
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
            {success && (
              <MuiAlert
                elevation={6}
                variant="filled"
                severity="success"
                className={classes.alert}
              >
                {successMessage}
              </MuiAlert>
            )}
            <Grid container justifyContent="center" className={classes.wrapper}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => props.history.push(`/admin/dtm/create`)}
              >
                新規DTM告知登録
              </Button>
            </Grid>
          </Grid>
          <Dialog open={isShowModal} onClose={() => setIsShowModal(false)}>
            <DialogContent>
              <DialogContentText>
                本当に削除してよろしいですか？
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={() => deleteDtm()}>
                はい
              </Button>
              <Button color="primary" onClick={() => setIsShowModal(false)}>
                いいえ
              </Button>
            </DialogActions>
          </Dialog>
        </>
      }
    />
  );
}

export default withRouter(Dtm);
